import type { ResourceForecastGridProps } from "@/features/Dashboard";
import { ResourceCard } from "@/features/Dashboard";
import { FORECAST_GRID_CLASSES } from "./resourceForecastGrid.definitions";

export default function ResourceForecastGrid({
  resourceForecast,
  onProposalClick,
  getTypeName,
  getTechnologyName,
  getProposalByName,
}: ResourceForecastGridProps) {
  const hasData = Object.keys(resourceForecast).length > 0;

  if (!hasData) {
    return (
      <div className={FORECAST_GRID_CLASSES.container}>
        <div className={FORECAST_GRID_CLASSES.header}>
          <h3 className={FORECAST_GRID_CLASSES.title}>Forecast de Recursos</h3>
          <p className={FORECAST_GRID_CLASSES.subtitle}>
            Recursos necessários para propostas com temperatura "Morno" ou
            superior
          </p>
        </div>
        <div className={FORECAST_GRID_CLASSES.emptyState}>
          <p className="text-raro-gray-500 text-center">
            Nenhuma proposta com temperatura "Morno" ou superior encontrada.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={FORECAST_GRID_CLASSES.container}>
      <div className={FORECAST_GRID_CLASSES.header}>
        <h3 className={FORECAST_GRID_CLASSES.title}>Forecast de Recursos</h3>
        <p className={FORECAST_GRID_CLASSES.subtitle}>
          Recursos necessários para propostas com temperatura "Morno" ou
          superior
        </p>
      </div>

      <div className={FORECAST_GRID_CLASSES.grid}>
        {Object.entries(resourceForecast).map(([typeId, resource]) => (
          <ResourceCard
            key={typeId}
            resource={resource}
            typeId={typeId}
            onProposalClick={onProposalClick}
            getTypeName={getTypeName}
            getTechnologyName={getTechnologyName}
            getProposalByName={getProposalByName}
          />
        ))}
      </div>
    </div>
  );
}
